module.exports = __webpack_public_path__ + "static/media/dsc_0681.df656336.jpg";